import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import api from '../../src/api/axios';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import notifications from './notifications';
import styles from '../App.module.css';
import { FaTimes } from 'react-icons/fa';

// 👇 importe o CreateCliente (ajuste o caminho se sua árvore for diferente)
import CreateCliente from '../components/Usuarios/CreateCliente';

Modal.setAppElement('#root'); // acessibilidade

let openModalFn; // referência global pra abrir o modal de fora

function Agendamentos() {
    const [notificationType, setNotificationType] = useState(0);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [showReceipt, setShowReceipt] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [agendamentos, setAgendamentos] = useState([]);

    // dados do cliente / listas para o CreateCliente
    const [clientesList, setClientesList] = useState([]);
    const [parceirosList, setParceirosList] = useState([]);
    const [showAllClientes, setShowAllClientes] = useState(false);
    const [selectedClienteId, setSelectedClienteId] = useState(null);
    const [clienteError, setClienteError] = useState(false);

    const [form, setForm] = useState({
        login: '',
        consuladoEntrevista: '',
        dataHorarioEntrevista: '',
        aprovado: false,
        clienteId: '',
        idDoCliente: '', // Inclui o id do cliente
        email: '',
        nome: '',
        contato: '',
        id: null,
        vendedor: 0,
        obs: '',
    });

    const cidades = {
        54: 'Brasília',
        55: 'Rio de Janeiro',
        56: 'São Paulo',
        57: 'Recife',
        128: 'Porto Alegre',
    };

    // expõe o openModal “real” para fora do componente
    useEffect(() => {
        openModalFn = openModal;
    }, []);

    useEffect(() => {
        if (notificationType && notifications[notificationType]) {
            notifications[notificationType]();
            setNotificationType(0);
        }
    }, [notificationType]);

    useEffect(() => {
        fetchAgendamentos();
        fetchClientes(); // carrega lista de clientes/pares p/ CreateCliente
    }, []);

    const fetchAgendamentos = async () => {
        try {
            const response = await api.get('/agendamentos');
            setAgendamentos(response.data);
        } catch (error) {
            console.error('Erro ao listar agendamentos:', error);
        }
    };

    const fetchClientes = async () => {
        try {
            const resCliente = await api.get('/clientesAgiliza');
            setClientesList(resCliente.data || []);
            const resParceiro = await api.get('/clientesParceiros');
            setParceirosList(resParceiro.data || []);
        } catch (error) {
            console.error('Erro ao carregar clientes/parceiros:', error);
        }
    };

    // abre modal; se receber cliente, pré-seleciona
    const openModal = (cliente = null, isEditMode = false) => {
        if (cliente) {
            setForm({
                id: cliente.id || null,
                consuladoEntrevista: cliente.consuladoEntrevista || '',
                dataHorarioEntrevista: cliente.dataHorarioEntrevista || '',
                aprovado: !!cliente.aprovado,
                clienteId: cliente.clienteId || '',
                idDoCliente: cliente.idDoCliente || '', // Inclui o id do cliente
                email: cliente.email || '',
                nome: cliente.nome || '',
                contato: cliente.contato || '',
                vendedor: cliente.vendedor || 0,
                obs: cliente.obs || '',
            });
            setSelectedClienteId(cliente.idDoCliente || null);
            setEditMode(isEditMode);
            setClienteError(false);
        } else {
            // abertura “limpa” (ex: CalendarioEntrevista)
            clearData();
            setSelectedClienteId(null);
            setEditMode(false);
            setClienteError(false);
        }
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setShowReceipt(true);
    };

    const copyToClipboard = () => {
        const textToCopy = `
Email: ${form.email}
vendedor: ${form.vendedor}

Nome: ${form.nome}
Contato: ${form.contato}

Agendamento:
Entrevista: ${form.dataHorarioEntrevista}, ${cidades[form.consuladoEntrevista] || ''}

Observação anotada:
${form.obs}
`.trim();

        const textarea = document.createElement('textarea');
        textarea.value = textToCopy;
        document.body.appendChild(textarea);
        textarea.select();
        try {
            document.execCommand('copy');
        } catch (err) {
            console.log('Erro ao copiar texto: ', err);
        }
        document.body.removeChild(textarea);
    };

    const closeReceipt = () => {
        setShowReceipt(false);
        setModalIsOpen(false);
        clearData();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    // quando o usuário seleciona um cliente no CreateCliente
    const handleClienteSelecionado = async (id) => {
        setSelectedClienteId(id || null);
        setForm((prev) => ({ ...prev, idDoCliente: id || '' }));
        setClienteError(false);

        // busca detalhes do cliente p/ exibir no recibo
        if (id) {
            console.log('Buscando cliente por ID:', id);
            try {
                const resp = await api.get(`/clienteAgiliza/${id}`);
                const c = resp.data || {};
                setForm((prev) => ({
                    ...prev,
                    nome: c.Nome || '',
                    contato: c.contato || '',
                }));
            } catch (err) {
                console.error('Erro ao buscar cliente por id:', err);
            }
        } else {
            setForm((prev) => ({ ...prev, nome: '', contato: '' }));
        }
    };

    const validateFormAgendamento = () => {
        // exige consulado, data/hora, email e cliente selecionado (necessário no backend)
        if (!form.consuladoEntrevista || !form.dataHorarioEntrevista || !form.email || (!form.clienteId && !form.idDoCliente)) {
            if (!form.clienteId) setClienteError(true);
            return false;
        }
        return true;
    };

    const clearData = () => {
        setForm({
            login: '',
            consuladoEntrevista: '',
            dataHorarioEntrevista: '',
            aprovado: false,
            clienteId: '',
            idDoCliente: '', // Inclui o id do cliente
            email: '',
            nome: '',
            contato: '',
            id: null,
            vendedor: 0,
            obs: '',
        });
    };

    const saveAgendamento = async () => {
        if (!validateFormAgendamento()) {
            setNotificationType(3); // “Campos Vazios”
            return;
        }

        try {
            let res;
            if (editMode) {
                res = await api.post('/updateAgendamento', form);
            } else {
                res = await api.post('/createAgendamento', form);
            }
            if (res.data.status === true) {
                fetchAgendamentos();
                closeModal();
                window.dispatchEvent(new Event('agendamento:changed'));

                // opcional: notificar outras páginas a recarregar
                // window.dispatchEvent(new Event('agendamento:changed'));
            } else {
                setNotificationType(2);
                // console.log('Erro ao salvar agendamento:', res.data.message);
            }
        } catch (error) {
            setNotificationType(2);
            // console.error('Erro ao salvar agendamento:', error);
        }
    };

    // ...código acima

    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '90%',
            maxWidth: '720px',
            maxHeight: '90vh',
            overflowY: 'auto',
            padding: 0,
            borderRadius: 16,

            // 👇 garante que o conteúdo do modal esteja acima do overlay e de tudo
            zIndex: 2147483648,     // “quase” o máximo suportado
            position: 'fixed',
        },
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.65)',

            // 👇 garante que o overlay esteja acima de tudo da página
            zIndex: 2147483647,     // maior que qualquer header/footer/toolbar
            position: 'fixed',
        },
    };


    return (
        <div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeReceipt}
                contentLabel="Agendamento Modal"
                style={customStyles}
            >
                {showReceipt ? (
                    <div className={styles.modal}>
                        <h2>Comprovante de Agendamento</h2>
                        <p>Email: {form.email}</p>
                        <p>vendedor: {form.vendedor}</p>
                        <p>Nome: {form.nome}</p>
                        <p>Contato: {form.contato}</p>
                        <p>Entrevista: {form.dataHorarioEntrevista}, {cidades[form.consuladoEntrevista]}</p>
                        <button type="button" onClick={copyToClipboard}>Copiar</button>
                        <button type="button" onClick={closeReceipt}>Fechar</button>
                    </div>
                ) : (
                    <div className={styles.modal} style={{ padding: 16 }}>
                        <h2 style={{ margin: '0 0 12px', color: 'var(--corPrimaria)' }}>
                            {editMode ? 'Editar Agendamento' : 'Novo Agendamento'}
                        </h2>

                        {/* 👉 topo: CreateCliente com seleção prévia (ou vazia) */}
                        {/* <div className={styles.cadastroClienteContainer} style={{ marginBottom: 12 }}> */}
                        <CreateCliente
                            clientesList={clientesList}
                            parceirosList={parceirosList}
                            handleToggleShowAll={() => setShowAllClientes(!showAllClientes)}
                            showAllClientes={showAllClientes}
                            onClienteSelecionado={handleClienteSelecionado}
                            errorCliente={clienteError}
                            selectedId={selectedClienteId}
                        />
                        {/* </div> */}

                        {/* E-mail (exigido pelo backend) */}
                        <div style={{ marginBottom: 12, marginTop: '20px' }}>
                            <input
                                type="email"
                                name="email"
                                value={form.email}
                                onChange={handleChange}
                                placeholder="E-mail (login do cliente)"
                                className={styles.inputFilter}
                                style={{ width: '90%' }}
                            />
                        </div>

                        {/* Consulado */}
                        <div style={{ marginBottom: 12, gap: 16, display: 'flex', flexWrap: 'wrap' }}>
                            <select
                                // className={styles.inputStyle}
                                name="consuladoEntrevista"
                                value={form.consuladoEntrevista}
                                onChange={handleChange}
                                className={styles.inputFilter}
                            // style={{ width: '90%' }}
                            >
                                <option value="">Selecione o Consulado</option>
                                <option value="54">Brasília</option>
                                <option value="56">São Paulo</option>
                                <option value="128">Porto Alegre</option>
                                <option value="55">Rio de Janeiro</option>
                                <option value="57">Recife</option>
                            </select>

                            <input
                                type="datetime-local"
                                name="dataHorarioEntrevista"
                                value={form.dataHorarioEntrevista}
                                onChange={handleChange}
                                placeholder="Data e Horário Entrevista"
                                className={styles.inputFilter}
                            />


                        </div>


                        <div style={{ display: 'flex', gap: 8 }}>
                            <button type="button" className={styles.cadastroCliente} onClick={saveAgendamento}>
                                Salvar
                            </button>
                            <button type="button" onClick={closeModal} title="Fechar sem salvar">
                                <FaTimes />
                            </button>
                        </div>
                    </div>
                )}
            </Modal>

            <NotificationContainer />
        </div>
    );
}

export default Agendamentos;

// função global para abrir o modal
export function openModal(cliente = null, isEditMode = false) {
    if (openModalFn) {
        openModalFn(cliente, isEditMode);
    }
}
